// @ts-expect-error injected at runtime via /public/runtimeConfig.js
const runtimeConfig = window.__polarisRuntimeConfig__ || {};

const { REACT_APP_AUTH_REDIRECT_URL, REACT_APP_ENV, REACT_APP_SOCKET_ENDPOINT, REACT_APP_THEME_URL } = process.env;

export const AUTH_REDIRECT_URL =
  runtimeConfig['AUTH_REDIRECT_URL'] ??
  REACT_APP_AUTH_REDIRECT_URL ??
  'http://localhost:17100/dev/login?referrer=https://localhost:17001';

export const ENVIRONMENT = runtimeConfig['ENVIRONMENT'] ?? REACT_APP_ENV ?? 'local';
export const SOCKET_ENDPOINT = runtimeConfig['SOCKET_ENDPOINT'] ?? REACT_APP_SOCKET_ENDPOINT ?? '/';
export const THEME_URL = runtimeConfig['THEME_URL'] ?? REACT_APP_THEME_URL ?? 'https://dev.eoilreports.com';

export const DEVELOPMENT = ['development', 'local'].includes(ENVIRONMENT);
